import gql from 'graphql-tag';

export const removePlayerMutation = gql`
	mutation RemovePlayer($id: ID!) {
		removeUser(id: $id) {
			id
		}
	}
`;
